import EventDTO from "./EventDTO";

export default class EventCLusterDTO {

  public id?: number;
  public events: Array<EventDTO>;
  public isClosed?: boolean;
  public isFull?: boolean;
  public redirectUrl?: String;


  constructor(id: number, events: Array<EventDTO>) {
    this.id = id;
    this.events = events;
  }

}
